import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { hideLoading, showLoading } from '@redux/actions';

function* getCarouselImagesSaga(action) {
  try {
    yield put(showLoading());
    const response = yield call(
      requestAPI,
      API.API_GET_CAROUSEL_IMAGES,
      API.GET,
      action.params
    );
    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_CAROUSEL_IMAGES_SUCCEEDED,
        payload: response
      });
    } else {
      yield put({
        type: types.GET_CAROUSEL_IMAGES_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_CAROUSEL_IMAGES_FAILED,
      error
    });
  } finally {
    yield put(hideLoading());
  }
}

export function* watchGetCarouselImages() {
  yield takeLatest(types.GET_CAROUSEL_IMAGES_REQUESTED, getCarouselImagesSaga);
}
